import { fmtUSDC } from '@shared/lib/format';
import type { Book } from '../types';
import { notifications } from '../ui/notifications';
import { deserializeAppError } from '@shared/error';

const valueCellByAssetId = new Map<string, HTMLElement>();
const avgEntryByAssetId = new Map<string, number | null>();

interface Position { asset_id: string; balance: string | number; avg_entry?: number; }

interface LoadPositionsParams {
  currentAssetIds: string[];
  getPositions: (filters?: { asset_ids?: string[] }) => Promise<{ ok: boolean; error?: string; data?: Position[] }>;
  positionsEl: HTMLElement;
  books: Map<string, Book>;
  positionsByAssetId: Map<string, number>;
}

export async function loadPositions({ currentAssetIds, getPositions: _getPositions, positionsEl, books, positionsByAssetId }: LoadPositionsParams): Promise<void> {
  try {
    const filters = Array.isArray(currentAssetIds) && currentAssetIds.length > 0 ? { asset_ids: currentAssetIds } : {};
    const res = await _getPositions(filters);
    const list = res?.ok && Array.isArray(res.data) ? res.data : [];
    if (!Array.isArray(list) || list.length === 0) { positionsEl.textContent = 'No positions'; return; }
    positionsByAssetId.clear();
    for (const p of list) { if (p?.asset_id) positionsByAssetId.set(p.asset_id, Number(p.balance)); }
    const container = document.createElement('div');
    container.style.display = 'grid'; container.style.gap = '10px'; container.style.fontSize = '16px'; container.style.lineHeight = '1.3';
    for (const p of list) {
      const row = document.createElement('div');
      row.style.display = 'grid'; row.style.gridTemplateColumns = '1fr auto'; row.style.gap = '12px'; row.style.alignItems = 'center'; row.style.padding = '8px 10px'; row.style.border = '1px solid var(--border)'; row.style.borderRadius = '6px';
      const book = books.get(p.asset_id);
      const name = book?.name || (p.asset_id?.slice(0, 10) + '…');
      const asset = document.createElement('div');
      try { const panel = document.querySelector(`.panel[data-asset-id="${p.asset_id}"]`); if ((panel as any)?.classList?.contains('team-a')) asset.style.color = 'var(--teamA)'; else if ((panel as any)?.classList?.contains('team-b')) asset.style.color = 'var(--teamB)'; } catch {}
      const sharesNum = Number(p.balance) / 1e6; const sharesDisplay = isFinite(sharesNum) ? sharesNum.toFixed(2) : '';
      asset.textContent = `${name}`;
      const shares = document.createElement('div');
      const bb = book?.bidPrices?.[0]; const ba = book?.askPrices?.[0];
      const mark = bb != null && ba != null ? (bb + ba) / 2 : (bb ?? ba);
      const valueUsd = mark != null && isFinite(sharesNum) ? sharesNum * Number(mark) : 0;
      const valueMicro = Math.round(valueUsd * 1e6);
      const valueDisplay = mark != null ? fmtUSDC(String(valueMicro)) : '-';
      const avgEntry = typeof p.avg_entry === 'number' ? p.avg_entry : null;
      const avgEntryDisplay = avgEntry != null ? avgEntry.toFixed(2) : '-';
      shares.textContent = `${sharesDisplay} shares  —  Entry ${avgEntryDisplay}  —  $${valueDisplay}`;
      valueCellByAssetId.set(p.asset_id, shares); avgEntryByAssetId.set(p.asset_id, avgEntry);
      row.appendChild(asset); row.appendChild(shares); container.appendChild(row);
    }
    positionsEl.innerHTML = ''; positionsEl.appendChild(container);
  } catch (e) { const error = e as Error; try { if ((e as any)?.appError) notifications.showAppError(deserializeAppError((e as any).appError)); } catch {} positionsEl.textContent = 'Error: ' + (error?.message ?? e); }
}
